var exitModal = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    window.addEventListener("load", function() {
      //exit intent modal
      var exitModal = document.getElementById("exit-window-modal");

      // Open Exit Modal only on Desktop
      if (exitModal && window.innerWidth > 980) {
        // if cursor leaves the current window
        document.addEventListener("mouseout", function(e) {
          if (e.clientY < 1) {
            var exitModal = document.getElementById("exit-window-modal");
            var hideExitModal = exitModal.classList.contains(
              "exit-window-modal-experiment-hide"
            );
            var exitModalCreative = exitModal.dataset.creative;

            if (
              !Cookie.read("closeExitModal-3")  &&
              !document.body.classList.contains("tingle-enabled") &&
              !hideExitModal
            ) {

              //Load amplitude event
              window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("OnExitIntentPopup", {
                'Interaction' : 'ModalLoad',
                'Creative' : exitModalCreative
              }) : '';

              var exitModalContent = document.getElementById(
                "exit-modal-popup"
              );
              if (exitModalContent) {
                var exitModal = new tingle.modal({
                  closeIconInverse: exitModalContent.dataset.closeIconInverse ? true : false,
                  onOpen: function() {
                    var tingleModal = document.getElementById(
                      "tingle-modal-box"
                    );
                    tingleModal.setAttribute("style", "width:auto !important;");

                    //Click Primary CTA event to add cookie closeExitModal
                    document.getElementById("exit-window-modal-cta-btn").addEventListener("click", function(e) {
                      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("OnExitIntentPopup", {
                        'Interaction' : 'PrimaryCTA',
                        'Creative' : exitModalCreative
                      }) : '';

                      Cookie.create("closeExitModal-3", "1", 30);
                    });

                    //Click secondary CTA event to add cookie closeExitModal
                    document.getElementById("exit-window-modal-cancel-btn").addEventListener("click", function(e) {
                      window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("OnExitIntentPopup", {
                        'Interaction' : 'SecondaryCTA',
                        'Creative' : exitModalCreative
                      }) : '';

                      Cookie.create("closeExitModal-3", "1", 30);

                      /*
                      * close modal without call close function. because on close its fire amplitude to avoid duplicate 
                      */
                      var elements = document.getElementsByClassName("tingle-modal--visible");
                      while (elements.length > 0) elements[0].remove();

                      //remove from body class
                      document.body.className = document.body.className.replace("tingle-enabled","");
                    });
                  },
                  onClose: function() {
                    //add cookie with 30 day expiry
                    Cookie.create("closeExitModal-3", "1", 30);

                    //Close amplitude event
                    window.hasOwnProperty('Amplitude') ? Amplitude.logEvent("OnExitIntentPopup", { 
                      'Interaction' : 'CloseButton',
                      'Creative' : exitModalCreative
                    }) : '';

                    exitModal.destroy();
                  }
                });
                exitModal.setContent(exitModalContent.innerHTML);
                exitModal.open();
              }
            }
          }
        });
      }
    });
  };

  init();
})();
